import { BaseFilterListRequestModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListRequestModel";

export class SupplierListRequestModel extends BaseFilterListRequestModel {
  id?: string;
  name?: string;
  displayName?: string;
  email?: string;
  phoneNumber?: string;
  order?: string;
  pagination?: boolean;

  constructor(data?: {
    id?: string;
    name?: string;
    status?: number;
    type?: number;
    displayName?: string;
    email?: string;
    phoneNumber?: string;
    order?: string;
    fromDate?: string;
    toDate?: string;
    pagination?: boolean;
    page?: number;
    limit?: number;
  }) {
    super();
    this.id = data?.id;
    this.name = data?.name;
    this.status = data?.status;
    this.type = data?.type;
    this.displayName = data?.displayName;
    this.email = data?.email;
    this.phoneNumber = data?.phoneNumber;
    this.order = data?.order;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.pagination = data?.pagination;
    this.page = data?.page;
    this.limit = data?.limit;
  }
}
